/**
 * Shared wallet type mapping utilities.
 *
 * Maps Privy walletClientType strings to human-readable labels
 * and icon types for display across the UI.
 */
import type { WalletIconType } from '@/types/wallet';

interface WalletTypeInfo {
  label: string;
  icon: WalletIconType;
}

const WALLET_TYPE_MAP: Record<string, WalletTypeInfo> = {
  metamask: { label: 'MetaMask', icon: 'metamask' },
  coinbase_wallet: { label: 'Coinbase Wallet', icon: 'coinbase' },
  wallet_connect: { label: 'WalletConnect', icon: 'walletconnect' },
  rainbow: { label: 'Rainbow', icon: 'rainbow' },
  phantom: { label: 'Phantom', icon: 'phantom' },
  privy: { label: 'Phenom Wallet', icon: 'privy' },
};

const DEFAULT_WALLET_INFO: WalletTypeInfo = { label: 'External Wallet', icon: 'generic' };

export function mapClientTypeToLabel(clientType: string): string {
  return (WALLET_TYPE_MAP[clientType] ?? DEFAULT_WALLET_INFO).label;
}

export function mapClientTypeToIcon(clientType: string): WalletIconType {
  return (WALLET_TYPE_MAP[clientType] ?? DEFAULT_WALLET_INFO).icon;
}
